export function getImgBaseUrl() {
    const imgBaseUrl = window.productPickerConfig.imageBaseUrl || {};
    return String(imgBaseUrl).replace(/\/+$/, '');
}

export function resolvePickerImageUrl(path) {
    if (!path) return '';

    const raw = String(path).trim();

    if (/^https?:\/\//i.test(raw)) return raw;

    const base = getImgBaseUrl();
    const clean = raw.replace(/^\/+/, '');

    return `${base}/${clean}`;
}
